import React, { Component } from "react";
import { Provider } from "react-redux";
import store from "./reducers/store";
import Router from "./Router";
import "./App.css";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <Provider store={store}>
                <Router />
            </Provider>
        );
    }
}

export default App;
